// The feed's market comes from two persisted sources: the current tab's
// session (cleared when the tab/browser closes) and localStorage (survives
// across tabs and sessions, and across logout). A new tab or a fresh
// browser launch has no session, so it must fall back to the persisted
// copy - otherwise the user is re-asked for their location on every visit.
export const resolveKnownUserLocation = (sessionUserLocation, persistedUserLocation) =>
  sessionUserLocation || persistedUserLocation || null;

// A session-restored location already went through the gitcha-availability
// check this browser session (isFromAvailableCities was set on the live
// state object before it was saved to sessionStorage). A persisted-only
// location (no session - new tab / fresh browser) may not have: entries saved
// before persistCheckedLocation existed were written before that check
// resolved and carry no flag. Skipping geolocation for it (no browser permission
// re-prompt) is still safe, but its availability has to be re-checked once,
// or a returning user in a covered city sees the "not available" empty state.
export const shouldRevalidatePersistedLocation = (sessionUserLocation, persistedUserLocation) =>
  !sessionUserLocation && !!persistedUserLocation;

// Persist a location only once its availability is known, flag included, so a
// restored copy can be trusted without re-asking. An uncovered location is
// dropped from storage rather than restored on every later visit. Returns the
// flagged location when available, otherwise null.
export const persistCheckedLocation = (location, isAvailable, store) => {
  if (isAvailable) {
    const checked = { ...location, isFromAvailableCities: true };
    store.set("userLocation", checked);
    return checked;
  }
  store.remove("userLocation");
  return null;
};
